












import {Component} from "vue-property-decorator"
import Vue from "vue"

import JdiContent from "@/components/JdiContent.vue"
import JdiStatus from "@/components/JdiStatus.vue"

@Component({
    components: {JdiStatus, JdiContent}
})
export default class Toolbar extends Vue {
}
